(function() {
  'use strict';
  angular.module('benefits')
    .component('benefitInfo', {
      bindings: {
        refId: '='
      },
      controller: ['benefitService', function benefitInfoController(benefitService) {
        var self = this;
        self.$onInit = function() {
          self.running = true;
          benefitService.checkPolicyForBenefitBlock(self.refId).then(function(data){
            self.isBenefitBlock = data;
          });
          benefitService.planSummaryPromise.then(function(data) {
            self.planSummary = data;
          });
          benefitService.benefitInfoPromise.then(function(data) {
            var maxCalculator = benefitService.getBenefitMaxCalculator(data.accumulators);
            self.benefitInfo = data;
            let hasCopay = !!_.find(data.categories, (cat) => {
              return cat.copayAmount !== null;
            });
            let hasCoinsurance = !!_.find(data.categories, (cat) => {
              return cat.coinsuranceInNetwork !== null;
            });
            if (hasCopay && hasCoinsurance) {
              self.coinsuranceHeadingClass = 'col-xs-1';
              self.deductibleHeadingClass = 'col-xs-2';
              self.copayHeadingClass = 'col-xs-2';
            } else if (hasCopay) {
              self.coinsuranceHeadingClass = 'hidden';
              self.deductibleHeadingClass = 'hidden';
              self.copayHeadingClass = 'col-xs-8';
            } else {
              self.coinsuranceHeadingClass = 'col-xs-2';
              self.deductibleHeadingClass = 'col-xs-2';
              self.copayHeadingClass = 'hidden';
            }

            _.each(data.categories, function(category) {
              category.inPlan = category.coinsuranceInNetwork || category.coinsuranceOutNetwork || (category.copayAmount != null);
              if (category.inPlan) {
                category.notInPlanClass = 'hidden';
                category.notInPlanClass = 'hidden';
                category.coinsuranceInClass = self.coinsuranceHeadingClass;
                category.deductibleInClass = self.deductibleHeadingClass;
                category.coinsuranceOutClass = self.coinsuranceHeadingClass;
                category.deductibleOutClass = self.deductibleHeadingClass;
                category.copayClass = self.copayHeadingClass;
                category.notCoveredClass = 'hidden';
                category.inNotCoveredClass = 'hidden';
                category.outNotCoveredClass = 'hidden';
                category.toggleClass = 'col-xs-1';
                let coveredForMember = benefitService.coveredForMember(category, data, maxCalculator);
                category.coveredForMember = coveredForMember;
                if (!coveredForMember.inNetwork && !coveredForMember.outNetwork) {
                  category.notCoveredClass = 'col-xs-8';
                  category.coinsuranceInClass = 'hidden';
                  category.deductibleInClass = 'hidden';
                  category.coinsuranceOutClass = 'hidden';
                  category.deductibleOutClass = 'hidden';
                  category.copayClass = 'hidden';
                } else if (!coveredForMember.inNetwork) {
                  category.coinsuranceInClass = 'hidden';
                  category.deductibleInClass = 'hidden';
                  if (hasCopay && hasCoinsurance) {
                    category.inNotCoveredClass = 'col-xs-3';
                    category.copayClass = 'col-xs-2';
                  } else if (hasCopay) {
                    category.inNotCoveredClass = 'col-xs-4';
                    category.copayClass = 'col-xs-4';
                  } else {
                    category.inNotCoveredClass = 'col-xs-4';
                  }
                } else if (!coveredForMember.outNetwork) {
                  category.coinsuranceOutClass = 'hidden';
                  category.deductibleOutClass = 'hidden';
                  if (hasCopay && hasCoinsurance) {
                    category.outNotCoveredClass = 'col-xs-3';
                    category.copayClass = 'col-xs-2';
                  } else if (hasCopay) {
                    category.outNotCoveredClass = 'col-xs-4';
                    category.copayClass = 'col-xs-4';
                  } else {
                    category.outNotCoveredClass = 'col-xs-4';
                  }

                }
              } else {
                category.coinsuranceInClass = 'hidden';
                category.deductibleInClass = 'hidden';
                category.coinsuranceOutClass = 'hidden';
                category.deductibleOutClass = 'hidden';
                category.copayClass = 'hidden';
                category.notInPlanClass = 'col-xs-9';
                category.notCoveredClass = 'hidden';
                category.inNotCoveredClass = 'hidden';
                category.outNotCoveredClass = 'hidden';
                category.toggleClass = 'hidden';
              }
              category.planType = self.benefitInfo.planType;
            });
            benefitService.filterCategories(data.categories, self.refId).then(function(categories){
              data.categories = categories;
            });
            self.serviceUnavailable = data.serviceUnavailable;
            self.running = false;
          });
          self.allOpen = false;

          self.toggleOpen = function() {
            self.allOpen = !self.allOpen;
            _.each(self.benefitInfo.categories,(category) => {
              category.open = self.allOpen && category.inPlan;
            });
          };
        };
      }],
      templateUrl: 'js/benefits/benefitInfo.html' + appVersion
    });
})();
